import { render, staticRenderFns } from "./BillInboxReadOnly.vue?vue&type=template&id=3ac93e80&scoped=true&"
import script from "./BillInboxReadOnly.vue?vue&type=script&lang=js&"
export * from "./BillInboxReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./BillInboxReadOnly.vue?vue&type=style&index=0&id=3ac93e80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac93e80",
  null
  
)

export default component.exports